<template>
  <div class="main-page">
    <div class="map-wraper">
      <div class="img-view-wraper">
        <ImageView
          v-if="floorMapImageUrlByFloorCode[currentFloorValue]"
          :src="floorMapImageUrlByFloorCode[currentFloorValue]"
        >
        </ImageView>
        <van-empty v-else description="暂无数据" />
      </div>
      <div class="search-wraper">
        <div class="title">教学楼</div>
        <dataForm
          :items="searchFormItems"
          ref="searchForm"
          class="search-form"
          autoSetDefaultValue
          labelWidth="0"
          :onOptionsLoadAfter="onOptionsLoadAfter"
        />
      </div>
    </div>
  </div>
</template>
<script>
import dataForm from "@/components/base/form/dataForm";
import classRoomApi from "@/api/classRoom.js";
import buildingManagementApi from "@/api/buildingManagement";
import ImageView from "@/components/tools/ImageView";

export default {
  components: {
    dataForm,
    ImageView
  },
  data() {
    return {
      searchFormItems: [
        {
          title: "",
          field: "FloorCode",
          itemRender: {
            name: "a-select",
            props: {
              api: classRoomApi.QueryMeetingRoomFloors,
              param: { FilterAccess: true },
              dataField: "Data",
              valueField: "FloorCode",
              labelField: "Name",
              defaultField: "IsSelected",
              titleWidth: "0px"
            },
            on: {
              change: this.onFloorCodeChange
            }
          }
        }
      ],
      floorMapImageUrlByFloorCode: {},
      currentFloorValue: ""
    };
  },
  mounted() {
    this.$refs.searchForm.setData({
      BuildingCode: "02"
    });
  },
  methods: {
    onOptionsLoadAfter(obj) {
      console.log(obj);
      this.fetchFloorImagesConfig("02");
      let formData = this.$refs.searchForm.getData();
      this.onFloorCodeChange(formData.FloorCode);
    },
    onFloorCodeChange(val) {
      this.currentFloorValue = val;
    },
    onBuildingCodeChange(buildingCode) {
      this.fetchFloorImagesConfig(buildingCode);
    },

    fetchFloorImagesConfig(buildingCode) {
      buildingManagementApi
        .QueryMeetingRoomBuildingMapImages({
          MeetingRoomBuildingCode: buildingCode
        })
        .then(res => {
          const floorList = res.Data;
          let data = {};
          for (let i = 0; i < floorList.length; i++) {
            const item = floorList[i];
            data[item.MeetingRoomFloorCode] = item.BuildingMapImageUrl;
          }
          this.floorMapImageUrlByFloorCode = data;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.map-wraper {
  // transform: rotate(90deg);
  // padding-left: 20px;
  display: flex;
  .img-view-wraper {
    flex: 1;
  }
}
.search-wraper {
  position: relative;
  width: 60px;
  padding: 10px 10px 0 5px;
  .search-form {
    transform: rotate(90deg);
  }
  .title {
    transform: rotate(90deg);
    position: absolute;
    top: 20px;
    right: 8px;
    font-size: 12px;
    font-weight: bold;
  }
  padding-top: 45px;
  /deep/.van-cell-group {
    display: inline-block;
  }
  /deep/.form-item-wraper {
    display: inline-block;
    width: 120px;
  }
  /deep/.form-item-wraper .van-field__control {
    text-align: left;
  }
}
</style>
